import getAddonBlocks from './blocks.js';
import getAddonViews, { addonLayoutViews } from './views.js';
import reducers from 'uniba-volto-persone/reducers';
import {
    SchedaPersonaEsistenteViewlet,
    TelefoniWidget,
    FaxWidget,
    SelectStrutturaWidget,
    CheckboxResponsabileWidget,
    SelectGenereWidget,
    RiassegnaAfferentiToolbar,
    EsportaAfferentiToolbar,
    SincronizzaAliasToolbar,
    RipristinaDefaultsToolbar,
    FixaNascostiToolbar
} from 'uniba-volto-persone/components';

export default function applyConfig(config) {
    // console.log("CONFIG PRIMA");
    // console.log(config);
    config.views = {
        ...config.views,
        ...getAddonViews(config)
    };

    const customBlocks = {
        ...getAddonBlocks(config),
    };

    config.blocks = {
        ...config.blocks,
        blocksConfig: { ...config.blocks.blocksConfig, ...customBlocks }
    };

    config.addonReducers = {
        ...config.addonReducers,
        ...reducers,
    };

    // config.addonRoutes = [
    //     ...config.addonRoutes,
    //     {
    //         path: '/esporta-afferenti',
    //         component: EsportaAfferentiPanel,
    //     },
    // ];

    config.settings.appExtras = [
        ...config.settings.appExtras,
        {
            match: '',
            component: SchedaPersonaEsistenteViewlet,
        },
        {
            match: '',
            component: RiassegnaAfferentiToolbar,
        },
        {
            match: '',
            component: EsportaAfferentiToolbar,
        },
        {
            match: '',
            component: SincronizzaAliasToolbar,
        },
        {
            match: '',
            component: RipristinaDefaultsToolbar,
        }, 
        {
            match: '',
            component: FixaNascostiToolbar,
        },
        // {
        //     match: '',
        //     component: GoogleAnalyticsPing,
        //     props: {
        //         'google-tag': '123456'
        //     }
        // },
        // {
        //     match: {
        //         path: '/blogs',
        //         exact: true,
        //     },
        //     component: WordClouds
        // },
        // {
        //     path: '/blog/**/edit',
        //     component: ExtraToolbarButton,
        // },
        // {
        //     match: {
        //         match: '/frontpage',
        //         ignore: '/frontpage/images',
        //     },
        //     component: FrontPage
        // },
    ];



    // RIMOSSO: utilizzo il proxy di ngnix per fare regole di routing
    // config.settings.externalRoutes = [
    //     ...config.settings.externalRoutes,
    //     {
    //         match: {
    //             path: '/query',
    //             exact: false,
    //             strict: false,
    //         },
    //         url: (payload) => {
    //             return config.settings.devProxyToApiPath + payload.location.pathname;
    //         },
    //     },
    // ];
    // ROUTES
    // config.addonRoutes = [
    //     ...config.addonRoutes,
    //     {
    //         path: '/rubrica/**/json',
    //         component: SchedaPersonaJson,
    //     },
    // ];
    config.widgets.widget.telefoni_widget = TelefoniWidget;
    config.widgets.widget.fax_widget = FaxWidget;
    config.widgets.widget.select_struttura_widget = SelectStrutturaWidget;
    config.widgets.widget.checkbox_responsabile_widget = CheckboxResponsabileWidget;
    config.widgets.widget.select_genere_ruolo = SelectGenereWidget;

    //VALIDATORS
    // config.registerUtility({
    //     type: 'validator',
    //     name: 'phoneNumberValidation',
    //     dependencies: {
    //         widget: 'telefoni_widget',
    //     },
    //     method: phoneValidator,
    // });

    // config.registerUtility({
    //     type: 'validator',
    //     name: 'faxValidation',
    //     dependencies: {
    //         widget: 'fax_widget',
    //     },
    //     method: faxValidator,
    // });
    // console.log("CONFIG DOPO");
    // console.log(config);

    config.settings.isMultilingual = false;
    config.settings.supportedLanguages = ["it"];
    return config;
}